export default __webpack_public_path__ + "static/14a5af4e719f951aa230c90a0f6b42b3.jpg";